<template>
  <div class="card-columns stats">
    <BaseCard
      v-for="(stat, key) in stats"
      :key="key"
      class="stats-stat text-center">
      <h5 class="card-title h3">
        <strong>{{ stat.stat }}</strong>
      </h5>
      <div>
        {{ stat.text }}
      </div>
    </BaseCard>
  </div>
</template>

<script>
import BaseCard from './BaseCard.vue'

export default {
  name: 'StatGrid',

  components: {
    BaseCard
  },

  props: {
    stats: { required: true, type: Array }
  }
}
</script>
